import { flexStyles } from '@/shared/theme/styled-components'

export const SDPaginatorOverrides = () => ({
  Root: {
    style: ({ $theme }) => ({
      ...flexStyles.center,
      height: 'auto',
      marginTop: '.5rem',
      paddingTop: '.5rem',
      paddingRight: '.5rem',
      paddingBottom: '.5rem',
      paddingLeft: '.5rem',
      backgroundColor: $theme.colors.overlayWhite50,
    }),
  },
})
